
export const truncateId = (id: string | undefined): string => {
  if (!id) return "";
  const maxLength = 8;
  if (id.length <= maxLength) {
    return id;
  }
  return id.substring(0, maxLength) + "...";
};

// Add a utility function to get the audio URL from various data formats
export const getAudioUrlFromData = (audioData: any): string | null => {
  if (!audioData) return null;
  
  // Handle different possible formats of audio data
  if (typeof audioData === 'string') {
    return audioData;
  }
  
  if (typeof audioData === 'object') {
    // Check common properties where audio URL might be stored
    if (audioData.url) return audioData.url;
    if (audioData.audio_url) return audioData.audio_url;
    if (audioData.audioUrl) return audioData.audioUrl;
    
    // If it's a Base64 string, create a data URL
    if (audioData.audioBase64) {
      return `data:audio/mp3;base64,${audioData.audioBase64}`;
    }
  }
  
  return null;
};

// Helper to get color for outcome badges
export const getOutcomeColor = (outcome: string): "default" | "destructive" | "success" | "secondary" | "outline" => {
  if (!outcome) return "default";
  
  const outcomeStr = outcome.toLowerCase();
  
  if (outcomeStr === 'reactivated' || outcomeStr === 'callback_requested') {
    return "success";
  }
  
  if (outcomeStr === 'not_interested' || outcomeStr === 'declined') {
    return "secondary";
  }
  
  if (outcomeStr === 'no_response' || outcomeStr === 'wrong_number') {
    return "destructive";
  }
  
  return "default";
};
